module.exports = __webpack_public_path__ + "img/Marca7.803e7128.jpg";